import { getEncoding } from "js-tiktoken";
import { size } from "./fp";

const enc = getEncoding("cl100k_base");

export const getTokenSize = (text: string) => size(enc.encode(text));
